import MessageComposer from './MessageComposer';

export default MessageComposer;
